import { IInterest, IUsageType } from "api/types";
import * as React from "react";
import { FunctionComponent } from "react";
import ElementBlock from "../Common/ElementBlock/ElementBlock";

interface IProps {
  elements?: IUsageType[];
  onChange?: (usageType: IUsageType) => void;
}

const UsageTypes: FunctionComponent<IProps> = ({ elements, onChange }) => {
  const onChangeHandler = (usageType: IUsageType) => () => {
    if (onChange) {
      onChange(usageType);
    }
  };
  return (
    <>
      {(elements || []).map((usageType: IInterest, key) => (
        <ElementBlock
          key={key}
          isUsageType
          name={usageType.name}
          onClick={onChangeHandler(usageType)}
          checked={usageType.checked}
        />
      ))}
    </>
  );
};

export default UsageTypes;



// WEBPACK FOOTER //
// ./src/components/ElementSelector/UsageTypes/UsageTypes.tsx